// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/drawer-template.svg'

export const DrawerTemplate = (props: React.SVGProps<SVGSVGElement>) => {
  return <TemplateSVG {...props} />
}
